<template>
  <v-card width="100%" flat tile>
    <v-card-title>
      <h3 class="text-h4">Clients</h3>
      <v-spacer></v-spacer>
<v-btn @click="toggleAdditionalFilter" color="primary">
  Expiring Contracts
</v-btn>

      <v-switch v-model="payAsYouGo" inset label="PAYG" class="mx-5" />

      <v-btn
        class="mb-auto mr-3"
        @click.prevent="toggleAdvanceSearch"
        dark
        fab
        color="secondary"
      >
        <v-icon>mdi-magnify</v-icon></v-btn
      >
      <v-dialog persistent v-model="dialog">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="modelPermissions.create"
            class="mb-auto"
            dark
            fab
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon></v-btn
          >
        </template>
        <client-dialog
          v-if="dialog"
          :clients="clients"
          :item="item"
          :close="close"
        ></client-dialog>
      </v-dialog>
    </v-card-title>

    <v-data-table
      v-model="selectedClient"
      show-select
      single-select
      :server-items-length="clients.total"
      :loading="loading"
      :headers="headers"
      :items="clients.data"
      :options.sync="options"
      :items-per-page="10"
      selectable-key="id"
    >
      <template v-slot:top>
        <v-expansion-panels disabled multiple v-model="advanceSearch" flat>
          <v-expansion-panel v-for="(item, i) in 1" :key="i">
            <v-expansion-panel-content>
              <v-row>
                <v-toolbar flat>
                  <v-text-field
                    clear-icon
                    clearable
                    v-model.lazy="search"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    single-line
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <date-picker v-model="fromDate" label="From"></date-picker>
                  <v-spacer></v-spacer>
                  <date-picker v-model="toDate" label="To"></date-picker>
                </v-toolbar>
              </v-row>
              <v-row>
                <v-col>
                  <select-categories
                    v-model="category"
                    label="Category"
                  ></select-categories>
                </v-col>
                <v-col>
                  <select-suburbs
                    v-model="suburb"
                    label="Suburb"
                  ></select-suburbs
                ></v-col>

                <v-col v-if="getRole !== 'salesRep'">
                  <select-employee v-model="employee" clearable />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-slot:item.report="{ item }">
        <v-btn text @click="clientReport(item)" color="secondary">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </template>

      <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
        <v-btn text @click="editItem(item)" color="primary">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
        <v-btn text @click="deleteItem(item)" color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :loading="loading" color="primary" @click="_changeModel(3)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ClientDialog from './ClientDialog'
import DatePicker from '../../../../components/DatePicker'
import SelectSuburbs from '../../../../components/SelectSuburbs'
import SelectCategories from '../../../../components/SelectCategories'
import { axios, Strings } from '../../../../utils'
import { mapActions, mapGetters, mapState } from 'vuex'
import SelectEmployee from '../../../../components/SelectEmployee.vue'
export default {
  name: 'ClientIndex',
  props: ['setClientData', 'changeModel', 'showMessage', 'client_id'],
  components: {
    ClientDialog,
    DatePicker,
    SelectCategories,
    SelectSuburbs,
    SelectEmployee
  },
  data() {
    return {
      advanceSearch: [],
      dialog: false,
      fromDate: null,
      toDate: null,
      category: '',
      suburb: '',
      options: {},
      item: {},
      search: '',
      selectedClient: [],
      employee: undefined
    }
  },

  computed: {
    ...mapState({
      headers: state => state.clients.headers,
      clients: state => state.clients.clients,
      loading: state => state.clients.loading,
    }),
    ...mapGetters([
      'permissions/getModelPermissions',
      'permissions/getRole',
      'clients/getPayAsYouGo',
      'clients/getAdditionalFilter'
    ]),
    additionalFilter: {
    get() {
      return this['clients/getAdditionalFilter']
    },
    set(value) {
      return this['clients/setAdditionalFilter'](value)
    }
  },
    modelPermissions() {
      return this['permissions/getModelPermissions']('client')
    },
    getRole() {
      return this['permissions/getRole']
    },
    payAsYouGo: {
      get() {
        return this['clients/getPayAsYouGo']
      },
      set(value) {
        return this['clients/setPayAsYouGo'](value)
      }
    }
  },
  methods: {
    ...mapActions(['clients/getClients', 'clients/setPayAsYouGo', 'clients/setAdditionalFilter', 'permissions/setRole']),
    toggleAdvanceSearch() {
      if (this.advanceSearch.length === 1) {
        this.advanceSearch = []
      } else {
        this.advanceSearch = [0]
      }
    },
    toggleAdditionalFilter() {
      this.additionalFilter = !this.additionalFilter;
      this.getClients(); // Fetch updated data
    }
    ,
    _changeModel(index) {
      if (this.client_id === null || this.client_id === undefined) {
        this.showMessage('Please select / create a client ', 'error')
      } else {
        this.changeModel(index)
      }
    },
    close() {
      this.item = {}
      this.dialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getClients() {
      this['clients/getClients']({
        options: this.options,
        search: this.search,
        employee: this.employee,
        additionalFilter: this.additionalFilter
      })
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.id}`)) {
        console.log('deleting client with id ', item.id)
        axios
          .delete(`api/admin/clients/${item.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.getClients()
            }
          })
          .catch(err => console.log(err))
      }
    },
    clientReport(item) {
      window.open(`${Strings.baseUrl}/client-report?id=${item.id}`, '_blank')
    }
  },

  watch: {
    options: {
      handler() {
        this.getClients()
        console.log('create listing: ' +JSON.stringify(this.modelPermissions))
        console.log('role' + this.role)
      },
      deep: true
    },
    additionalFilterActive() {
      
    this.getClients(); // Fetch data whenever the filter state changes
  },
    dialog: {
      handler() {
        this.getClients()
      },
      deep: true
    },
    search: {
      handler() {
        this.getClients()
      },
      deep: true
    },

    employee: {
      handler() {
        this.getClients()
      },
      deep: true
    },

    payAsYouGo: {
      handler() {
        this.getClients()
      },
      deep: true
    },
    selectedClient: function(value) {
      if (value && value.length > 0 && value[0].id !== undefined) {
        this.showMessage('Client Selected with id ' + value[0].id, 'success')
        this.setClientData(value[0].id, value[0].client_name, value[0].email)
      } else {
        this.setClientData(null, null, null)
      }
    }
  },

  created() {
    // Hydrate role early so modelPermissions is ready on first render after reload
    if (!this.getRole) {
      const storedRole = window.localStorage.getItem('role')
      if (storedRole) {
        this['permissions/setRole'](storedRole)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
